import { render } from "./Warning.vue?vue&type=template&id=32aa5a6c"
import script from "./Warning.vue?vue&type=script&lang=js"
export * from "./Warning.vue?vue&type=script&lang=js"

import exportComponent from "/builds/swift-dental/my-swift-dental/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__